import { urls } from "../constants";
import api from "./api";

const addProduct = async ({ formData }) => {
  try {
    // Axios auto-detects FormData and sets the correct Content-Type with boundary
    const response = await api.post(urls.addOrUpdateOrDeleteProduct, formData);
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const updateProduct = async ({ formData, productId }) => {
  try {
    const response = await api.put(`${urls.addOrUpdateOrDeleteProduct}/${productId}`, formData);
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const deleteProduct = async ({ productId }) => {
  try {
    const response = await api.delete(`${urls.addOrUpdateOrDeleteProduct}/${productId}`);
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const updateProductStatus = async ({ productId, status }) => {
  try {
    const response = await api.put(`${urls.updateProductStatus}/${productId}`, { status });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const getProducts = async ({ page, limit, laboratoryId }) => {
  try {
    const response = await api.get(urls.getProducts, {
      params: {
        laboratoryId,
        page: page ? page : 1,
        limit: limit ? limit : 100
      }
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const getProductsFilter = async ({
  text,
  page,
  limit,
  laboratoryId,
  doctorId,
}) => {
  try {
    const params = {
      text,
      laboratoryId,
      page: page ? page : 1,
      limit: limit ? limit : 100
    };
    if (doctorId) params.doctorId = doctorId;

    const response = await api.get(urls.getProducts, { params });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const getProductsPendingApproval = async ({ page, limit }) => {
  try {
    const response = await api.get(urls.getProductsPendingApproval, {
      params: {
        status: 0,
        page: page ? page : 1,
        limit: limit ? limit : 100
      }
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const getProductsPendingApprovalFilter = async ({
  text,
  page,
  limit,
}) => {
  try {
    const response = await api.get(urls.getProductsPendingApproval, {
      params: {
        status: 0,
        text,
        page: page ? page : 1,
        limit: limit ? limit : 100
      }
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const getProductsAssigned = async ({
  laboratoryId,
  page,
  limit,
  text,
}) => {
  try {
    const response = await api.get(urls.getProductsAssigned, {
      params: {
        text,
        laboratoryId,
        page: page ? page : 1,
        limit: limit ? limit : 100
      }
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const getAllAssignProducts = async ({
  page,
  limit,
  text,
  comuna,
  estado,
  startDate,
  endDate,
}) => {
  try {
    const params = {
      text,
      page: page ? page : 1,
      limit: limit ? limit : 100,
      status: estado,
      startDate,
      endDate
    };

    // handling comuna array manually because axios default generic params serializer might differ from what the backend expects
    // if backend expects &comuna=A&comuna=B, axios usually does comuna[]=A or similar depending on serializer.
    // The original code appended strings manually.
    // To be safe, let's use the URLSearchParams or paramsSerializer if we want valid axios usage, 
    // but modifying the URL string structure directly is also fine with axios if we pass the URL string.

    let baseUrl = `${urls.getAllAssignProducts}?text=${text}&page=${page ? page : 1
      }&limit=${limit ? limit : 100
      }&status=${estado}&startDate=${startDate}&endDate=${endDate}`;

    if (typeof comuna === "object") {
      comuna.map((c) => (baseUrl += `&comuna=${c}`));
    }

    const response = await api.get(baseUrl);
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const assignProdutc = async ({ payload }) => {
  try {
    const response = await api.post(urls.assignProduct, payload);
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const assignProductCategory = async ({ payload }) => {
  try {
    const response = await api.post(urls.assignProductCategory, payload);
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const assignProductsFiles = async ({ formData }) => {
  try {
    const response = await api.post(urls.assignProductsFiles, formData);
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const getMostRequestedProducts = async ({ page, limit, text }) => {
  try {
    const response = await api.get(urls.getMostRequestedProducts, {
      params: {
        page: page ? page : 1,
        limit: limit ? limit : 100,
        text
      }
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const deleteProductsAssignmet = async ({ array }) => {
  try {
    const response = await api.post(urls.deleteProductsAssignmet, { array });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const getPatientRepetitionRate = async ({
  page,
  limit,
  laboratoryId,
  text,
}) => {
  try {
    const response = await api.get(urls.getRepetitionRate, {
      params: {
        laboratoryId,
        page: page ? page : 1,
        limit: limit ? limit : 100,
        text
      }
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const getSamplesToRunOut = async ({
  page,
  limit,
  laboratoryId,
  text,
}) => {
  try {
    const response = await api.get(urls.getSamplesToRunOut, {
      params: {
        laboratoryId,
        page: page ? page : 1,
        limit: limit ? limit : 100,
        text
      }
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const getSamplesToExpire = async ({
  page,
  limit,
  laboratoryId,
  text,
}) => {
  try {
    const response = await api.get(urls.getSamplesToExpire, {
      params: {
        laboratoryId,
        page: page ? page : 1,
        limit: limit ? limit : 100,
        text
      }
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const getSamplesAvailable = async ({
  page,
  limit,
  laboratoryId,
  text,
}) => {
  try {
    const response = await api.get(urls.getSamplesAvailable, {
      params: {
        laboratoryId,
        page: page ? page : 1,
        limit: limit ? limit : 100,
        text
      }
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const getAllProductStatus = async () => {
  try {
    const response = await api.get(urls.getAllProductsStatus);
    return {
      status: response.status,
      data: response.data.result,
    };
  } catch (error) {
    console.error("Error al obtener los estados de los productos:", error);
    throw error;
  }
};

const uploadProductStatus = async ({ productId, statusId }) => {
  try {
    const response = await api.put(`${urls.uploadProductStatus}/${productId}`, { statusId });
    return {
      status: response.status,
      data: response.data.result,
      message: response.data.message,
    };
  } catch (error) {
    console.error("Error al actualizar los estados de los productos:", error);
    throw error;
  }
};

const reAssignProduct = async ({ data }) => {
  try {
    const response = await api.post(urls.reAssignProduct, data);
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const exportAssignments = async ({
  text,
  page,
  limit,
  status,
  startDate,
  endDate,
  comuna,
}) => {
  let baseUrl = `${urls.exportAssignments}?text=${text}&page=${page}&limit=${limit}&status=${status}&startDate=${startDate}&endDate=${endDate}`;
  if (typeof comuna === "object") {
    comuna.map((c) => (baseUrl += `&comuna=${c}`));
  }

  try {
    const response = await api.get(baseUrl, {
      responseType: 'blob'
    });
    return {
      status: response.status,
      response: response.data
    };
  } catch (error) {
    return {
      status: error.response?.status,
      response: error.response?.data
    };
  }
};

const productsServices = Object.freeze({
  addProduct,
  updateProduct,
  updateProductStatus,
  deleteProduct,
  getProducts,
  getProductsFilter,
  //getProductsAssignedFilter,
  getProductsPendingApproval,
  getProductsPendingApprovalFilter,
  getProductsAssigned,
  assignProdutc,
  assignProductCategory,
  assignProductsFiles,
  getMostRequestedProducts,
  deleteProductsAssignmet,
  getPatientRepetitionRate,
  getSamplesToRunOut,
  getSamplesToExpire,
  getSamplesAvailable,
  getAllAssignProducts,
  getAllProductStatus,
  uploadProductStatus,
  exportAssignments,
  reAssignProduct,
});

export default productsServices;
